import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { html as $ } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { property as e } from '../../../../node_modules/@lit/reactive-element/decorators/property.js';
import '../../../../node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import { ifDefined as l } from '../../../../node_modules/lit-html/directives/if-defined.js';
import { unsafeHTML as o } from '../../../../node_modules/lit-html/directives/unsafe-html.js';
import '../../atoms/buttons/enums.js';
import { isRTL } from '../../utilities/dom-helpers/index.js';
import css_248z from './link-button.scss.js';

class LinkButton extends s {
    constructor() {
        super(...arguments);
        this.label = 'Link button';
        this.href = '#';
        this.target = '_self';
        this.disabled = false;
        this.rtl = false;
        this.ariaLabel = '';
        this.isNoFollow = false;
    }
    _getRelAttribute() {
        const parts = [];
        if (this.target === '_blank') {
            parts.push('noopener', 'noreferrer');
        }
        if (this.isNoFollow) {
            parts.push('nofollow');
        }
        return parts.length > 0 ? parts.join(' ') : '';
    }
    render() {
        var _a;
        const ariaDisabled = this.disabled ? 'true' : undefined;
        const tabIndex = this.disabled ? '-1' : undefined;
        const direction = this.rtl || isRTL() ? 'rtl' : 'ltr';
        const relAttribute = this._getRelAttribute();
        const ariaLabelValue = ((_a = this.ariaLabel) === null || _a === void 0 ? void 0 : _a.trim()) || undefined;
        return $ `<a class="link-button" href="${this.href}" target="${this.target}" dir="${direction}" aria-disabled="${l(ariaDisabled)}" aria-label="${l(ariaLabelValue)}" tabindex="${l(tabIndex)}" rel="${l(relAttribute || undefined)}" @click="${this.handleClick}"><span class="link-button__text">${o(this.label)}</span> <span class="link-button__icon-wrapper" aria-hidden="true"><svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none"><path d="M16.4363 12.15H0V9.45H16.4363L8.87625 1.89L10.8 0L21.6 10.8L10.8 21.6L8.87625 19.71L16.4363 12.15Z" fill="#AA0061"/></svg></span></a>`;
    }
    handleClick(e) {
        if (this.disabled) {
            e.preventDefault();
            e.stopPropagation();
        }
    }
}
LinkButton.styles = css_248z;
__decorate([
    e({ type: String })
], LinkButton.prototype, "label", void 0);
__decorate([
    e({ type: String })
], LinkButton.prototype, "href", void 0);
__decorate([
    e({ type: String })
], LinkButton.prototype, "target", void 0);
__decorate([
    e({ type: Boolean, reflect: true })
], LinkButton.prototype, "disabled", void 0);
__decorate([
    e({ type: Boolean })
], LinkButton.prototype, "rtl", void 0);
__decorate([
    e({ type: String })
], LinkButton.prototype, "ariaLabel", void 0);
__decorate([
    e({ type: Boolean })
], LinkButton.prototype, "isNoFollow", void 0);
customElements.define('link-button-item', LinkButton);

export { LinkButton };
